import request from "@/utils/request";

// 获取试卷列表
export function getExamPaperList(data) {
  return request({
    url: "local_exam_search_paper",
    method: "GET",
    params: data,
  });
}
// 编辑试卷
export function getEditExamPaper(data) {
  return request({
    url: "local_exam_edit_paper",
    method: "GET",
    params: data,
  });
}
// 添加试卷
export function getAddExamPaper(data) {
  return request({
    url: "local_exam_create_paper",
    method: "GET",
    params: data,
  });
}
// 试卷详情
export function getExamPaperDetail(data) {
  return request({
    url: "local_exam_read_paper",
    method: "GET",
    params: data,
  });
}
// 删除试卷
export function getDelExamPaper(data) {
  return request({
    url: "local_exam_delete_paper",
    method: "GET",
    params: data,
  });
}
// 批量审核试卷
export function auditPapers(data) {
  return request({
    url: "local_exam_check_paper",
    method: "GET",
    params: data,
  });
}
// 发布试卷
export function releasePapers(data) {
  return request({
    url: "local_exam_publish_paper",
    method: "GET",
    params: data,
  });
}
// 随机抽题
export function randomQuestion(data) {
  return request({
    url: "local_exam_random_question",
    method: "GET",
    params: data,
  });
}
